module.exports = __webpack_public_path__ + "img/17.3c1cc27f.png";